/// <amd-module name="TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionActions" />
import { createAction, ActionsUnion } from "redux/Utils/ActionHelper";
import { GitHubConnectionData } from "TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionDataSource";

export const GitHubConnectionActions = {
    initView: (isToggleEnabled: boolean) => createAction(GitHubConnectionActionTypes.InitView, isToggleEnabled),
    initialLoadSucceeded: (data: GitHubConnectionData) => createAction(GitHubConnectionActionTypes.InitialLoadSucceeded, data),
    markCollection: (toggleSetting: boolean, collectionId: string) =>
        createAction(GitHubConnectionActionTypes.MarkCollection, { toggleSetting, collectionId }),
    toggleWasToggled: (toggleSetting: boolean) => createAction(GitHubConnectionActionTypes.ToggleWasToggled, toggleSetting),
    logTelemetry: (action: string, properties?: { [key: string]: any }) =>
        createAction(GitHubConnectionActionTypes.logTelemetry, { action, properties })
};

export const enum GitHubConnectionActionTypes {
    InitView = "GitHubConnection/Init",
    InitialLoadSucceeded = "GitHubConnection/InitialLoadSucceeded",
    MarkCollection = "GitHubConnection/MarkCollection",
    ToggleWasToggled = "GitHubConnection/ToggleWasToggled",
    logTelemetry = "GitHubConnection/LogTelemetry"
}

export type GitHubConnectionActions = ActionsUnion<typeof GitHubConnectionActions>;
